import { ProjectCharge, Project, EeCodeRecord, TaskRate } from "~/gql/types";
import moment from "moment";
import { ExpenseRate } from "~/gql/ExpenseRate";
import { ChargeFormFieldValues } from "../types";

export const getInitialFormValues = (
  charge: ProjectCharge,
  eeCode: EeCodeRecord,
  project?: Project
): ChargeFormFieldValues => {
  const rate =
    charge && charge.rateSheetName
      ? charge.type === "Expense"
        ? ({ name: charge.label } as ExpenseRate)
        : ({ name: charge.label } as TaskRate)
      : null;

  const initialFormValues = {
    rate,
    rateAmount: `${charge.rate}`,
    unit: charge.unit!,
    date: moment(charge.date, "YYYY-MM-DD"),
    notes: charge.notes ?? null,
    billable: charge.billable,
    type: charge.type,
    customRateLabel: !charge.rateSheetName ? charge.label : null,
    useCustomRate: charge.rateSheetName ? false : true,
    eeCode,
    quantity: charge.quantity ?? null,
    rates: null,
    editNotes: null,
    employee: charge.employee ?? null,
    project: (project || charge.project) ?? null,
    taxable: charge.taxable,
    // Seeded so pass-through fields round-trip: `rateSheetName` is kept
    // (the fake `rate` above discards it) and the original `label` is echoed
    // for charges the form can't yet re-derive it for.
    rateSheetName: charge.rateSheetName ?? null,
    label: charge.label,
  };

  return initialFormValues;
};
